// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/agenttools/v1/catalog.proto (package mono.agenttools.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetToolRequest, GetToolResponse, ListToolsRequest, ListToolsResponse, WatchToolsRequest, WatchToolsResponse } from "./catalog_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * AgentToolCatalogService is the source of truth for what the shanks agent can
 * do. It exposes the agent's tool registry — tool descriptors with display
 * hints, input/output schemas, and project-type activation rules — so that
 * the frontend, other services, and shanks itself can discover capabilities
 * without duplicating metadata.
 *
 * This is the *agent tool* catalog. It is distinct from:
 *   - mono.capability.v1 (vendor/company capabilities, owned by zou)
 *   - ryugu's program capability breakdown (CS/D/DS/ITM/ITO/MS)
 * Do not conflate.
 *
 * @generated from service mono.agenttools.v1.AgentToolCatalogService
 */ export const AgentToolCatalogService = {
    typeName: "mono.agenttools.v1.AgentToolCatalogService",
    methods: {
        /**
     * ListTools returns all registered tool descriptors, optionally filtered.
     *
     * @generated from rpc mono.agenttools.v1.AgentToolCatalogService.ListTools
     */ listTools: {
            name: "ListTools",
            I: ListToolsRequest,
            O: ListToolsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetTool returns a single tool descriptor by name.
     *
     * @generated from rpc mono.agenttools.v1.AgentToolCatalogService.GetTool
     */ getTool: {
            name: "GetTool",
            I: GetToolRequest,
            O: GetToolResponse,
            kind: MethodKind.Unary
        },
        /**
     * WatchTools streams catalog changes (reserved for v1.1; currently unimplemented).
     *
     * @generated from rpc mono.agenttools.v1.AgentToolCatalogService.WatchTools
     */ watchTools: {
            name: "WatchTools",
            I: WatchToolsRequest,
            O: WatchToolsResponse,
            kind: MethodKind.ServerStreaming
        }
    }
};
